// Tartalék adatok: csak akkor jelennek meg, ha az admin adatai nem tölthetők be.
// status: "published" = jelentkezhető, "soon" = hamarosan (nincs jelentkezés)
// sessions: későbbi időpontok helye ugyanahhoz a programhoz (még nem jelenik meg)
export const GROUP_PROGRAMS = [
  {
    id: "lathatatlanul-mukodteto-ero",
    number: "1. Kiscsoportos alkalom",
    title: "A LÁTHATATLANUL MŰKÖDTETŐ ERŐ",
    subtitle: "Mi húzódik meg a visszatérő reakciók, döntések és élethelyzetek mögött?",
    description: [
      "Vajon valóban te irányítod az életed, vagy vannak olyan mélyben működő programok és lenyomatok, amelyek észrevétlenül befolyásolják a döntéseidet, reakcióidat és kapcsolataidat?",
      "Ismerős, amikor már rengeteget dolgoztál magadon, mégis újra és újra ugyanazokban a helyzetekben találod magad?",
      "Ezen a tematikus Forrás-Kód® alkalmon a felszíni működések mögé tekintünk, hogy felismerjük a háttérben meghúzódó mechanizmusokat, és a Forrás energiájával teret nyissunk az egyéni kiigazításoknak, a felszabadulásnak és a kikönnyülésnek.",
    ],
    heart_after_last: true,
    info: [
      { label: "Időpont", value: "2026. november – pontosítás alatt" },
      { label: "Időtartam", value: "120 perc" },
      { label: "Forma", value: "Online, kiscsoportos alkalom" },
      { label: "Létszám", value: "Maximum 14 fő,\na személyes figyelem érdekében" },
      { label: "Részvételi díj", value: "12.000 Ft/fő" },
    ],
    status: "published",
    sessions: [],
  },
  {
    id: "kapcsolataink-halojaban",
    number: "2. Kiscsoportos alkalom",
    title: "KAPCSOLATAINK HÁLÓJÁBAN",
    subtitle: "Mi minden húzódik meg kapcsolataink láthatatlan szálai mögött?",
    description: [
      "Vajon miért találkozunk újra és újra hasonló élethelyzetekkel, emberi minőségekkel és kapcsolati játszmákkal? Mi van akkor, ha kapcsolataink láthatatlan szálai sokkal messzebbre nyúlnak, mint azt valaha gondoltuk?",
      "Családi minták, láthatatlan kötések, kimondatlan fogadalmak és mélyen őrzött lenyomatok… Vajon mi minden befolyásolja észrevétlenül, hogyan kapcsolódunk önmagunkhoz és másokhoz?",
      "Ezen a tematikus Forrás-Kód® alkalmon kapcsolataink mélyebb összefüggéseire tekintünk rá, és a Forrás energiájával teret nyitunk az egyéni kiigazításoknak, a régi működések átrendeződésének és a tisztább kapcsolódás lehetőségének.",
    ],
    heart_after_last: true,
    info: [
      { label: "Időpont", value: "2026. november – pontosítás alatt" },
      { label: "Időtartam", value: "120 perc" },
      { label: "Forma", value: "Online, kiscsoportos alkalom" },
      { label: "Létszám", value: "Maximum 14 fő,\na személyes figyelem érdekében" },
      { label: "Részvételi díj", value: "12.000 Ft/fő" },
    ],
    status: "published",
    sessions: [],
  },
];

